import React, { useState, useEffect } from "react"
import closeIcon from "@/public/icons/close.svg"
import playIcon from "@/public/icons/play-white.svg"
import {
  addAnalyticsVideoClick,
  addAnalyticsVideoClose,
} from "@/components/MyFavorites/analytics"
const VideoTile = ({ url = "", data = {} }) => {
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    if (showModal) {
      document.body.classList.add("modal-open")
    } else {
      document.body.classList.remove("modal-open")
    }
  }, [showModal])

  const handleModal = (isOpen = false) => {
    const videoName =
      data?.name &&
      (data.name["en-US"]?.toLowerCase() ||
        data.name["en-CA"]?.toLowerCase() ||
        "")
    const videoId = url && url.split("/")?.length ? url.split("/").pop() : ""
    if (isOpen) {
      addAnalyticsVideoClick(videoName, url, videoId)
    } else {
      addAnalyticsVideoClose(videoName, url, videoId)
    }
    setShowModal(prevShowModal => !prevShowModal)
  }

  return (
    <>
      <div className="video-tile" tabIndex="0" role="link">
        <span className="play-icon" onClick={() => handleModal(true)}>
          <img src={playIcon?.src} alt="" />
        </span>
        <video controls>
          <source src={url} type="video/mp4" />
        </video>
      </div>

      {showModal && (
        <div className="favorites-lightbox">
          <div className="favorites-lightbox__modal">
            <div className="favorites-lightbox__close">
              <img
                src={closeIcon?.src}
                alt="close"
                onClick={() => handleModal(false)}
              />
            </div>
            <video
              autoPlay
              webkit-playsinline="true"
              playsInline
              preload="none"
              controls
            >
              <source src={url} type="video/mp4" />
            </video>
          </div>
        </div>
      )}
    </>
  )
}

export default VideoTile
